<template>
    <div class="drawing-container">
        <div class="wrapper">
            <div class="choose-dimensions" v-if="!ui.drawing.ready" v-html="ui.t('worktopChooseDimensions')"></div>

            <div class="selections" v-if="ui.visibleSelections && ui.visibleSelections.length > 0">
                <div v-for="selection in ui.visibleSelections" :key="selection.value" class="list-group-item">
                    <div class="container">
                        <div class="image" v-if="selection.image" :style="{ 'background-image': ui.getBackgroundImageUrl(selection.image, 600)! }"></div>
                    </div>
                </div>
            </div>

            <div class="worktop" :style="worktopStyles()" :class="worktopClasses()">
                <div class="backstyle-container">
                    <div class="raised-back" v-if="state.backStyle == 'BackRaised'">
                        <div class="height-container">
                            <div class="title backstyle">
                                {{ ui.t("worktopBackStyleHeightTitle") }} 50
                            </div>
                            <div class="bar vertical">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dimensions">
                    <div class="length" :class="dimensionClasses('worktopLength')">
                        <div class="title">
                            {{ ui.t("length") }} {{ ui.worktopLength }}
                        </div>

                        <div class="bar horizontal"></div>

                        <div class="sub" v-if="ui.drawing.gapLength > 0 && (sinkDimensionsXVisible() || hobcutoutDimensionsXVisible())"
                            :style="{ left: ui.drawing.gapDistanceLeft + '%', width: ui.drawing.gapLength + '%' }">
                            <div class="title">{{ ui.drawing.gapValue }}</div>
                            <div class="bar horizontal"></div>
                        </div>

                        <div class="sub" v-if="sinkDimensionsXVisible()" :style="{ left: ui.drawing.sinkDistanceLeft + '%', width: ui.drawing.sinkLength + '%' }">
                            <div class="title">{{ ui.sink.length }}</div>
                            <div class="bar horizontal"></div>
                        </div>

                        <div class="sub" v-if="hobcutoutDimensionsXVisible()"
                            :style="{ left: ui.drawing.hobcutoutDistanceLeft + '%', width: ui.drawing.hobcutoutLength + '%' }" :class="dimensionClasses('hobcutoutLength')">
                            <div class="title">{{ ui.hobcutoutLength }}</div>
                            <div class="bar horizontal"></div>
                        </div>

                        <div class="sub" :class="{}" v-if="functionalAreaDimensionsVisible()"
                            :style="{ left: ui.drawing.functionalAreaLeft + '%', width: ui.drawing.functionalAreaLength + '%' }">
                            <div class="title">
                                {{ ui.drawing.functionalAreaLengthValue }}
                            </div>
                            <div class="bar horizontal"></div>
                        </div>
                    </div>

                    <div class="width" :class="dimensionClasses('worktopWidth')">
                        <div class="title">
                            {{ ui.t("depth") }} {{ ui.worktopWidth }}
                        </div>
                        <div class="bar vertical"></div>
                    </div>
                </div>

                <div class="height-container" :class="dimensionClasses('worktopHeight')">
                    <div class="height" :style="{ height: ui.drawing.worktopHeight + 'px'}">
                        <div class="top"></div>
                        <div class="base"></div>
                        <div class="bar vertical"></div>
                    </div>
                    <div class="title">{{ ui.t("thickness") }} {{ ui.worktopHeight }}</div>
                </div>

                <div class="functional-area-edge left" :style="functionalAreaStyles()" :class="{ 'with-faucet': state.faucetHole != '0' || state.extraHole != '0' || state.extraHole2 != '0' }" v-if="state.functionalArea == 'L'"></div>
                <div class="functional-area-edge right" :style="functionalAreaStyles()"  :class="{ 'with-faucet': state.faucetHole != '0' || state.extraHole != '0' || state.extraHole2 != '0' }" v-if="state.functionalArea == 'R'"></div>
                
                <div class="sink-container" :class="sinkContainerClasses()" :style="sinkContainerStyles()" v-if="sinkVisible()">
                    <div class="functional-area functional-area-left" v-if="state.functionalArea == 'L'"></div>
                    <div class="sink" :style="sinkStyles()">
                        <div class="hole" :style="getSinkHoleStyles(state.faucetHole)" :class="getSinkHoleClasses(state.faucetHole)" v-if="state.faucetHole != '0'"></div>
                        <div class="hole" :style="getSinkHoleStyles(state.extraHole)" :class="getSinkHoleClasses(state.extraHole)" v-if="state.extraHole != '0'"></div>
                        <div class="hole" :style="getSinkHoleStyles(state.extraHole2)" :class="getSinkHoleClasses(state.extraHole2)" v-if="state.extraHole2 != '0'"></div>
                    </div>
                    <div class="functional-area functional-area-right" v-if="state.functionalArea == 'R'"></div>
                </div>

                <div class="sink-safety-area"
                    v-if="ui.sink.sinkCount > 1 && state.edgeProfileCode == 'Straight' && sinkVisible() && state.productFamilyCode == 'seven'"
                    :style="sinkSafetyAreaStyles()">
                </div>

                <div class="sink-x" v-if="sinkDimensionsXVisible()">
<!--                     <div class="sub" v-if="state.functionalArea == 'L'" :style="{ left: `calc(${cssSinkDistanceLeft()}% - 45px)`, width: '45px' }" :class="dimensionClasses('sinkDistanceLeft')">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ 225 }}</div>
                    </div> -->
                    <div class="sub" :style="{ width: cssSinkDistanceLeft() + '%' }" :class="dimensionClasses('sinkDistanceLeft')">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ sinkDistanceLeftValue() }}</div>
                    </div>

                    <!-- <div class="sub disabled" :style="{ left: ui.drawing.sinkDistanceLeft + '%', width: ui.drawing.sinkLength + '%' }">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ ui.sink.length }}</div>
                    </div> -->
                    <div class="sub" :style="{ right: 0, width: cssSinkDistanceRight() + '%' }" :class="dimensionClasses('sinkDistanceRight')">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ sinkDistanceRightValue() }}</div>
                    </div>
<!--                     <div class="sub" v-if="state.functionalArea == 'R'" :style="{ right: `calc(${cssSinkDistanceRight()}% - 45px)`, width: '45px' }" :class="dimensionClasses('sinkDistanceRight')">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ 225 }}</div>
                    </div> -->
                </div>

                <div class="functional-area-y disabled" v-if="functionalAreaDimensionsVisible()" :style="{ left: (ui.drawing.functionalAreaLeft + ui.drawing.functionalAreaLength) + '%'}">
                    <div class="container">
                        <div class="back" :style="{ height: ui.drawing.functionalAreaBack + '%' }">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.drawing.functionalAreaBackValue }}</span>
                        </div>
                        <div class="width" :style="{ height: (ui.drawing.functionalAreaWidth / ui.worktopWidth * 100) + '%'}">
                            <div class="title">
                                {{ ui.drawing.functionalAreaWidth }}
                            </div>
                            <div class="bar vertical"></div>
                        </div>
                        <div class="front" :style="{ height: ui.drawing.functionalAreaFront + '%' }">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.drawing.functionalAreaFrontValue }}</span>
                        </div>
                    </div>
                </div>

                <div class="sink-y disabled" :style="sinkMeasurementsStyles()" v-if="sinkDimensionsYVisible()">
                    <div class="container">
                        <div class="back" :style="{ height: ui.drawing.sinkDistanceBack + '%' }">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.sinkDistanceBack }}</span>
                        </div>
                        <div class="width" :style="{ height: ui.drawing.sinkWidth + '%' }">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.sink.width }}</span>
                        </div>
                        <div class="front" :style="{ height: ui.drawing.sinkDistanceFront + '%' }">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.sinkDistanceFront }}</span>
                        </div>
                    </div>
                </div>

                <div class="hobcutout-container" :class="{ 'placement-error': ui.hobcutoutHasPlacementError }" :style="hobcutoutContainerStyles()" v-if="hobcutoutVisible()">
                    <div class="hobcutout" :style="hobcutoutStyles()"></div>
                </div>

                <div class="hobcutout-x" v-if="hobcutoutDimensionsXVisible()">
                    <div class="sub" :style="{ width: cssHobcutoutDistanceLeft() + '%' }" :class="dimensionClasses('hobcutoutDistanceLeft')">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ hobcutoutDistanceLeftValue() }}</div>
                    </div>
                    <!-- <div class="length disabled" :style="{ width: ui.drawing.hobcutoutLength + '%' }" :class="dimensionClasses('hobcutoutLength')">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ ui.hobcutoutLength }}</div>
                    </div> -->
                    <div class="sub" :style="{ right: 0, width: cssHobcutoutDistanceRight() + '%' }" :class="dimensionClasses('hobcutoutDistanceRight')">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ hobcutoutDistanceRightValue() }}</div>
                    </div>
                </div>

                <div class="hobcutout-y" :style="hobcutoutMeasurementsStyles()" v-if="hobcutoutDimensionsYVisible()">
                    <div class="container disabled">
                        <div class="back" :style="{ height: ui.drawing.hobcutoutDistanceBack + '%' }" :class="dimensionClasses('hobcutoutDistanceBack')">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.hobcutoutDistanceBack }}</span>
                        </div>
                        <div class="width" :style="{ height: ui.drawing.hobcutoutWidth + '%' }" :class="dimensionClasses('hobcutoutWidth')">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.hobcutoutWidth }}</span>
                        </div>
                        <div class="front" :style="{ height: ui.drawing.hobcutoutDistanceFront + '%' }" :class="dimensionClasses('hobcutoutDistanceFront')">
                            <div class="bar vertical"></div>
                            <span class="title">{{ ui.hobcutoutDistanceFront }}</span>
                        </div>
                    </div>
                </div>

                <div class="summary-x" v-if="summaryDimensionsVisible()">
                    <div class="distance-bar disabled" v-for="distance in ui.drawing.summaryDistances" :key="distance.cssPositionLeft"
                         :style="{ left: distance.cssPositionLeft + '%', width: distance.cssWidth + '%' }">
                        <div class="bar horizontal"></div>
                        <div class="title">{{ distance.widthValue.toFixed(0) }}</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { ref } from "vue"; 
import { useState, useUI } from '../store';


const props = defineProps<{
    editableFields: string[]
}>()

const { ui } = useUI();
const { state } = useState();
const previewSelection = ref(null);

const functionalAreaStyles = () => {
    return {
        left: functionalAreaLeft() + '%',
        bottom: functionalAreaBottom() + '%',
        width: functionalAreaLength() + '%',
        height: functionalAreaHeight() + '%'
    }
}

const functionalAreaLeft = () => {
    if (!state.functionalArea || state.functionalArea == "0")
        return 0;
    return ((ui.sinkDistanceLeft ?? 0) - (state.functionalArea == "R" ? 16 : 200)) / (ui.worktopLength ?? 0) * 100
}

const functionalAreaLength = () => {
    if (!state.functionalArea || state.functionalArea == "0")
        return 0;

    return (ui.sink.length + 216) / (ui.worktopLength ?? 0) * 100   ;
}

const functionalAreaBottom = () => {
    if (!state.functionalArea || state.functionalArea == "0")
        return 0;

    return (ui.sinkDistanceFront - 16) / (ui.worktopWidth ?? 0) * 100; 
}

const functionalAreaHeight = () => {
    if (!state.functionalArea || state.functionalArea == "0")
        return 0;

    return (ui.sink.width + 101) / ui.worktopWidth * 100;
}

const worktopStyles = () => {
    return {
        opacity: ui.drawing.ready ? 1 : 0,
        width: ui.drawing.worktopLength + "%",
        height: ui.drawing.worktopWidth + "%",
    };
}

const worktopClasses = () => {
    return {
        "raised-edge": state.edgeProfileCode == "Raised"
    };
}

const sinkSafetyAreaStyles = () => {
    return {
        height: ui.drawing.safetyAreaWidth + "%",
        width: ui.drawing.safetyAreaLength + "%",
        left: ui.drawing.safetyAreaLeft + "%"
    };
}

const sinkDistanceLeftValue = () => {
    return state.sinkDistanceMeasuredTo == "edge"
        ? ui.sinkDistanceLeft
        : ui.sinkDistanceLeftCenter;
}

const cssSinkDistanceLeft = () => {
    return state.sinkDistanceMeasuredTo == "edge"
        ? ui.drawing.sinkDistanceLeft
        : ui.drawing.sinkDistanceLeftCenter;
}

const sinkDistanceRightValue = () => {
    return state.sinkDistanceMeasuredTo == "edge"
        ? ui.sinkDistanceRight
        : ui.sinkDistanceRightCenter;
}

const cssSinkDistanceRight = () => {
    return state.sinkDistanceMeasuredTo == "edge"
        ? ui.drawing.sinkDistanceRight
        : ui.drawing.sinkDistanceRightCenter;
}

const hobcutoutDistanceLeftValue = () => {
    return state.hobcutoutDistanceMeasuredTo == "edge"
        ? ui.hobcutoutDistanceLeft
        : ui.hobcutoutDistanceLeftCenter;
}

const cssHobcutoutDistanceLeft = () => {
    return state.hobcutoutDistanceMeasuredTo == "edge"
        ? ui.drawing.hobcutoutDistanceLeft
        : ui.drawing.hobcutoutDistanceLeftCenter;
}

const hobcutoutDistanceRightValue = () => {
    return state.hobcutoutDistanceMeasuredTo == "edge"
        ? ui.hobcutoutDistanceRight
        : ui.hobcutoutDistanceRightCenter;
}

const cssHobcutoutDistanceRight = () => {
    return state.hobcutoutDistanceMeasuredTo == "edge"
        ? ui.drawing.hobcutoutDistanceRight
        : ui.drawing.hobcutoutDistanceRightCenter;
}

const sinkContainerStyles = () => {
    return {
        width: ui.drawing.sinkLength + "%",
        height: ui.drawing.sinkWidth + "%",
        left: ui.drawing.sinkDistanceLeft + "%",
        top: ui.drawing.sinkDistanceBack + "%"
    };
}

const sinkContainerClasses = () => {
    let classes = [ ];

    if(ui.sink.sinkCount) {
        classes.push('sinks-' + ui.sink.sinkCount.toString().replace(".", "-"));
    }

    classes.push("w-" + ui.worktopWidth.toString());
    classes.push(ui.sink.code?.toLowerCase());
    classes.push(state.sinkHandedness?.toLowerCase());

    if (ui.sinkHasPlacementError)
        classes.push("placement-error");

    return classes;
}

const hobcutoutContainerStyles = () => {
    return {
        width: ui.drawing.hobcutoutLength + "%",
        height: ui.drawing.hobcutoutWidth + "%",
        left: ui.drawing.hobcutoutDistanceLeft + "%",
        bottom: ui.drawing.hobcutoutDistanceFront + "%"
    };
}

const sinkMeasurementsStyles = () => {
    return {
        left: state.functionalArea == "R" ? `calc(${ui.drawing.sinkDistanceLeft}% + 45px)` : ui.drawing.sinkDistanceLeft + "%",
        width: ui.drawing.sinkLength + "%",
    };
}

function getSinkHoleStyles(hole: string) {
    if (hole.toLowerCase() != "m" || !ui.sink.centerPointOffset)
        return "";

    return `left: ${(50 - ui.sink.centerPointOffset)}%`;
}

function getSinkHoleClasses(hole: string) {
    return "hole-" + hole.toLowerCase();
}

const hobcutoutMeasurementsStyles = () => {
    return {
        left: ui.drawing.hobcutoutDistanceLeft + "%",
        width: ui.drawing.hobcutoutLength + "%",
    };
}

const sinkVisible = () => {
    return ui.sink.drawing && state.sinkDistanceX && ui.sink.length > 0;// && !ui.sinkHasPlacementError;
}

const sinkDimensionsXVisible = () => {
    return sinkVisible() && state.sinkDistanceX && (props.editableFields && props.editableFields.indexOf("sinkDistanceLeft") != -1);
}

const sinkDimensionsYVisible = () => {
    return sinkVisible() && props.editableFields && props.editableFields.indexOf("sinkDistanceFront") != -1;
}

const hobcutoutVisible = () => {
    return state.hobcutout == '1'
        && ui.hobcutoutLength! > 0
        && ui.hobcutoutWidth! > 0
        && ui.hobcutoutDistanceLeft! > 0
        && ui.hobcutoutDistanceFront > 0
        ;//&& !ui.hobcutoutHasPlacementError;
}

const functionalAreaDimensionsVisible = () => {
    return state.functionalArea && state.functionalArea != "0" && props.editableFields?.indexOf("functionalArea") > -1;
}

const hobcutoutDimensionsXVisible = () => {
    return hobcutoutVisible() && (props.editableFields && props.editableFields.indexOf("hobcutoutLength") != -1);
}

const hobcutoutDimensionsYVisible = () => {
    return hobcutoutVisible() && (props.editableFields && props.editableFields.indexOf("hobcutoutDistanceFront") != -1);
}

const summaryDimensionsVisible = () => {
    return props.editableFields && props.editableFields.indexOf("summary") != -1;
}

const sinkStyles = () => {
    return {
        "background-image": "url('" + ui.drawing.sinkDrawing + "')"
    };
}

const hobcutoutStyles = () => {
    return {
        "background-image": "url('" + ui.drawing.hobcutoutDrawing + "')"
    };
}

function dimensionClasses(fieldName: string) {
    let classes = [];

    if (!props.editableFields || props.editableFields.indexOf(fieldName) == -1)
        classes.push("disabled");

    if (ui.focusedFieldName == fieldName)
        classes.push("focused");

    return classes;
}

</script>
